import { Badge } from "@/components/ui/badge";

/**
 * The payment state of a single order, as a pill.
 *
 * Extracted from InfinityCaseDetail so the case popup and the Infinity Touch
 * orders list state it identically (TR-26 item 5) — the same reason
 * shared/Pagination.jsx was extracted rather than copied a fourth time.
 *
 * `pending` is the fallback rather than a blank: an order row is written before
 * its PaymentIntent exists, so a missing payment_status means "not paid yet",
 * never "paid".
 */
const PAYMENT_BADGE = {
  paid: "border-emerald-200 bg-emerald-50 text-emerald-700",
  pending: "border-amber-200 bg-amber-50 text-amber-700",
  failed: "border-red-200 bg-red-50 text-red-700",
  refunded: "border-slate-200 bg-slate-50 text-slate-600",
};

const PAYMENT_LABEL = {
  paid: "Paid",
  pending: "Payment pending",
  failed: "Payment failed",
  refunded: "Refunded",
};

export const paymentLabelOf = (status) => PAYMENT_LABEL[status] || PAYMENT_LABEL.pending;

/**
 * @param {string}  status    order.payment_status
 * @param {boolean} hidePaid  omit the pill entirely when the order is paid. Used by
 *                            the orders list, where the common case is paid and a
 *                            green pill on every row is noise; the case popup shows
 *                            all four states because it is a per-order history.
 */
export default function PaymentStatusBadge({ status, hidePaid = false, className = "" }) {
  if (hidePaid && status === "paid") return null;
  return (
    <Badge variant="outline" className={`${PAYMENT_BADGE[status] || PAYMENT_BADGE.pending} ${className}`}>
      {paymentLabelOf(status)}
    </Badge>
  );
}
